import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { ReviewIcon } from "../../assets/Icon/dashboredIcon";
import { CrossIcon, ErrorIcon, SuccessIcon } from "../../assets/Icon/ToastIcon";
import { useMediaQuery } from "@mui/material";
import theme from "../../theme";

interface ToastProps {
  message: string;
  title: string;
  isCross?: boolean;
  type?: "success" | "error" | "info" | "warning";
  duration?: number;
  onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({
  message,
  title,
  isCross,
  type = "info",
  duration = 20000,
  onClose,
}) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ≤600px
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const bgColor = {
    success: "bg-green-500",
    error: "bg-red-500",
    info: "bg-blue-500",
    warning: "bg-yellow-500",
  };

  const borderColor = {
    success: "#4CAF50",
    error: "#F44336",
    info: "#2196F3",
    warning: "#E7AB12",
  };

  const iconMap = {
    success: <SuccessIcon />,
    error: <ErrorIcon />,
    info: <ReviewIcon />,
    warning: <ReviewIcon />,
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0, x: -50 }}
      exit={{ opacity: 0, y: -20 }}
      className="fixed"
      style={{
        width: "367px",
        height: "auto",
        top: "20px",
        left: isMobile ? 10 : "",
        right: isMobile ? 5 : 20, // ← 10px on mobile, otherwise 20px
        // width: isMobile ? "calc(100% - 20px)" : 367,
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        border: "1px solid transparent",
        borderLeft: `7px solid ${borderColor[type]}`,
        backgroundColor: "#fff",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        opacity: 1,
        zIndex: 99999,
        padding: "16px",
        borderRadius: "8px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          position: "relative",
        }}
      >
        <div>{iconMap[type]}</div>
        <div style={{ flex: 1 }}>
          <span
            style={{
              color: borderColor[type],
              fontWeight: 600,
              fontSize: "18px",
              fontFamily: "Plus Jakarta Sans",
              lineHeight: "22.68px",
              textAlign: "left",
              textDecoration: "none",
              display: "block",
            }}
          >
            {title}
          </span>

          {message && (
            <div
              style={{
                marginTop: "4px",
                paddingLeft: "",
                fontFamily: "Plus Jakarta Sans",
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "17.64px",
                textAlign: "left",
                color: "#333",
              }}
            >
              {message &&
                message
                  ?.split(",")
                  .map((item, index) => <div key={index}>{item?.trim()}</div>)}
            </div>
          )}
        </div>
        <div
          onClick={onClose}
          style={{
            position: "absolute",
            background: "none",
            border: "none",
            top: isCross ? "20%" : "2%",
            right: isCross ? "12px" : "3px",
            color: "#888",
            cursor: "pointer",
            fontSize: "16px",
            fontWeight: 600,
            transform: "translateY(-50%)",
          }}
        >
          <CrossIcon />
        </div>
      </div>
    </motion.div>
  );
};

export default Toast;
